import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Rx';

@Injectable()
export class FileService
{
	/**
	 * Files.
	 */
	private files = [];

	/**
	 * Subject for shown state.
	 */
	private filesSubject = new Subject<any>();

	/**
	 * Observable for shown state.
	 */
	public store = this.filesSubject.asObservable();

	/**
	 * Add a file.
	 */
	public addFile(file: any)
	{
		this.files.push(file);
		this.filesSubject.next(this.files);
	}

	/**
	 * Remove a file.
	 */
	public removeFile(index: number)
	{
		this.files.splice(index, 1);
		this.filesSubject.next(this.files);
	}

	/**
	 * Get the store.
	 */
	public getStore(): Array<File>
	{
		return this.files;
	}

	/**
	 * Get file names.
	 */
	public getFilenames(): Array<string>
	{
		let filenames = [];

		for (let data of this.files)
		{
			filenames.push(data.name);
		}

		return filenames;
	}

	/**
	 * Clear all files.
	 */
	public clearFiles()
	{
		this.files = [];
		this.filesSubject.next(this.files);
	}
}



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/services/file.service.ts